import { Viewport } from './viewport';
import { Socket } from './socket';

const surface = document.querySelector('main div');

export class Magnet
{
    static #active = null;
    static #moved = false;
    static #offset = { x: 0, y: 0 };

    static drag (event)
    {
        if (Math.abs(event.clientX - this.#active.dataset.startX) > 5 ||
            Math.abs(event.clientY - this.#active.dataset.startY) > 5) {
            this.#moved = true;
        }

        const {x, y} = Viewport.getViewportCoordinates(
            event.clientX,
            event.clientY,
            this.#offset.x,
            this.#offset.y,
        );

        this.#active.style.left = `${x}px`;
        this.#active.style.top = `${y}px`;

        Socket.broadcast(this.#active.id, parseFloat(this.#active.dataset.rotation) || 0, x, y);
    }

    static drop ()
    {
        if (!this.#active) {
            return;
        }

        this.#active.classList.remove('dragging');
        this.#active = null;
    }

    static init (magnets)
    {
        for (const magnet of Object.values(magnets)) {
            Magnet.#create(magnet);
        }
    }

    static isActive ()
    {
        return this.#active !== null;
    }

    static move (id, position)
    {
        const magnet = id instanceof HTMLElement ? id : document.getElementById(id);
        if (!magnet) {
            return;
        }

        if (position.r) {
            magnet.style.setProperty('--rotation', `${position.r}deg`);
            magnet.dataset.rotation = position.r;
        }

        if (position.x) {
            magnet.style.left = `${position.x}px`;
        }

        if (position.y) {
            magnet.style.top = `${position.y}px`;
        }

        if (position.z) {
            magnet.style.zIndex = position.z;
        }
    }

    static pickUp (event)
    {
        this.#active = event.target;
        this.#active.classList.add('dragging');
        this.#active.dataset.startX = event.clientX;
        this.#active.dataset.startY = event.clientY;

        this.#moved = false;

        this.#offset = Viewport.getElementOffset(
            event.clientX,
            event.clientY,
            this.#active.style.left,
            this.#active.style.top,
        );

        Socket.emit('liftMagnet', { id: event.target.id });
    }

    static release (event)
    {
        this.#active.classList.remove('dragging');
        let r = parseFloat(this.#active.dataset.rotation) || 0;

        if (this.#moved === false) {
            r += event.shiftKey ? -15 : 15;
            Magnet.move(this.#active, { r });
        }

        Socket.emit('moveMagnet', {
            id: this.#active.id,
            r,
            x: parseFloat(this.#active.style.left),
            y: parseFloat(this.#active.style.top),
        });

        this.#active = null;
    }

    static #create (data)
    {
        if (document.getElementById(data.id)) {
            return;
        }

        const magnet = document.createElement('article');
        magnet.id = data.id;
        magnet.dataset.color = data.color;
        magnet.innerText = data.letter;
        surface.appendChild(magnet);

        this.move(magnet, data);
    }
}
